import Modal from 'lib/components/modals/modal'
import { cn } from 'lib/util/cn'
import { DownloadIcon, ExternalLinkIcon, ForwardIcon } from 'lucide-react'

import { MenuItem } from 'lib/components/menu-item/menu-item'

import AddToBrandScreen from './add-to-brand-screen'
import AddToProjectScreen from './add-to-project-screen'
import AddToScreen from './add-to-screen'
import ExportScreen from './export-screen'
import AddToRequestScreen from './add-to-request-screen'
import DownloadScreen from './download-screen'
import { useFilesContext } from '../files-context'
import { useUserContext } from 'providers/user-provider'

export enum FileExportModalMode {
  DOWNLOAD = 'download',
  EXPORT = 'export',
  ADD_TO = 'add_to',
  REQUEST = 'request',
  PROJECT = 'project',
  BRAND = 'brand',
  NONE = null,
}

// To be used later if/when we have more vendors
// enum ExportVendors {
//   stockpress = 'stockpress',
// }

// const ExportVendor = ({ vendor }: { vendor: ExportVendors }) => {
//   return (
//     <div className="tw-flex tw-w-min tw-cursor-pointer tw-flex-col tw-items-center tw-gap-1">
//       <IconButton color="secondary" size="sm">
//         <img src={`/images/vendors/${vendor}.png`} width={24} height={24} />
//       </IconButton>
//       <div className="tw-text-xs">Stockpress</div>
//     </div>
//   )
// }

export const Screen = () => {
  const { mode } = useFilesContext()

  const Screens = {
    [FileExportModalMode.ADD_TO]: <AddToScreen />,
    [FileExportModalMode.REQUEST]: <AddToRequestScreen />,
    [FileExportModalMode.EXPORT]: <ExportScreen />,
    [FileExportModalMode.DOWNLOAD]: <DownloadScreen />,
    [FileExportModalMode.PROJECT]: <AddToProjectScreen />,
    [FileExportModalMode.BRAND]: <AddToBrandScreen />,
  }

  return Screens[mode]
}

const hideSidebarScreens = [FileExportModalMode.REQUEST, FileExportModalMode.PROJECT, FileExportModalMode.BRAND]

const FileModal = () => {
  const { setMode, mode, setSelectedFile } = useFilesContext()
  const { user } = useUserContext()

  return (
    <Modal
      open={!!mode}
      size="md"
      setOpen={() => {
        setSelectedFile(null)
        setMode(null)
      }}
      className={cn('tw-p-4', 'tw-relative tw-min-h-[550px] tw-max-w-2xl tw-overflow-y-auto !tw-p-0')}
    >
      <div className="tw-flex tw-min-h-[550px]">
        {!hideSidebarScreens.includes(mode) && (
          <div className="tw-flex tw-flex-col tw-gap-2 tw-border tw-border-b-0 tw-border-l-0 tw-border-t-0 tw-border-solid tw-border-gray-200 tw-px-2 tw-py-6">
            <MenuItem
              item={{ label: 'Add to...', Icon: ForwardIcon }}
              selected={mode === FileExportModalMode.ADD_TO}
              onClick={() => setMode(FileExportModalMode.ADD_TO)}
              cmp="div"
            />
            <MenuItem
              item={{ label: 'Download', Icon: DownloadIcon }}
              selected={mode === FileExportModalMode.DOWNLOAD}
              onClick={() => setMode(FileExportModalMode.DOWNLOAD)}
              cmp="div"
            />
            {user?.subscribedToPlatformPro && (
              <MenuItem
                intent="rowMobileCol"
                item={{
                  label: 'Export',
                  Icon: ExternalLinkIcon,
                  RightIcon: () => {
                    return (
                      <div
                        className={cn(
                          'tw-ml-auto tw-rounded tw-bg-cornflower-100 tw-font-semibold tw-text-cornflower-800',
                          'tw-absolute tw-right-0 tw-top-0 tw-flex tw-min-h-3 tw-min-w-3 tw-rounded-full tw-text-[0px] tw-leading-[0px] md:tw-static md:tw-rounded md:tw-bg-cornflower-100 md:tw-px-2 md:tw-py-1 md:tw-text-xs md:tw-text-cornflower-800',
                        )}
                      >
                        New
                      </div>
                    )
                  },
                }}
                onClick={() => setMode(FileExportModalMode.EXPORT)}
                selected={mode === FileExportModalMode.EXPORT}
              />
            )}
          </div>
        )}
        <div className="tw-w-full tw-p-4">{<Screen />}</div>
      </div>
    </Modal>
  )
}

export default FileModal
